module.exports = __webpack_public_path__ + "static/myconids-015e0e7dc1ef7ccc9587f19b17a189fd.jpg";